import React, { Component } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import DesignResourcesPanel from '../designResourcesPanel';

const PageSize = 30;

class BackgroundPanel extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: [],
			page: 0,
			searchActive: false,
			searchKeywords: ''
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData = () => {
		var payload = {
			type: 'image',
			sub_type: 'background',
			page_no: this.state.page,
			size: PageSize,
		}

		fetch(global.config.server_path + 'design_resource/get/', { method: 'POST', headers: { 'Content-Type': 'application/json' }, 'credentials': 'include', body: JSON.stringify(payload) })
			.then(resp => resp.json())
			.then(resp => resp.data.docs)
			.then(data => {
				data.map(o => o.resource_id = o._id)
				this.setState({
					data: this.state.data.concat(data),
					page: this.state.page + 1

				})
			})
	}

	render() {
		return (
			<React.Fragment>
				<InfiniteScroll
					dataLength={this.state.data ? this.state.data.length : 0}
					next={this.fetchData}
					hasMore={true}
					height={'calc(100vh - 198px)'}
					endMessage={<h4>No more results.</h4>}
				>
					<DesignResourcesPanel
						// annotate={true}
						on_drag_start={this.props.on_drag_start}
						on_drag={this.props.on_drag}
						on_drag_end={this.props.on_drag_end}
						on_click={this.props.on_click}
						image_height={'126px'}
						col_size={6}
						resources={this.state.data} />
				</InfiniteScroll>
			</React.Fragment>
		);
	}
}

export default BackgroundPanel;